<template>
  <modal
    :show.sync="showRejectModal"
    modalContentClasses=""
    modalClasses="modal-alert"
    type="mini"
    @close="closeModalReject"
  >
    <div
      class="col-12 pt-4 pb-2"
      :class="{ 'is-invalid': $v.optionRejected.$error }"
    >
      <div class="text-center">
        <img
          src="~rhomtrip_assets/src/img/icons/alerts/question.png"
          alt="question"
          class="icon-modal"
        />
        <h2 class="modal-title mb-1">
          Reject Reservation
        </h2>
      </div>
      <p>Are you sure you want to Reject this reservation?</p>
      <p>To continue select a <strong>Reason:</strong></p>

      <b-form-radio-group
        id="radio-optionRejected"
        v-model="optionRejected"
        aria-describedby="ariaDescribedby"
        name="radio-optionRejected"
        stacked
        size="md"
      >
        <b-form-radio value="No Availability" tabindex="15"
          >No Availability</b-form-radio
        >
        <b-form-radio value="Wrong Service Rate"
          >Wrong Service Rate</b-form-radio
        >
        <b-form-radio value="Other">Other</b-form-radio>
      </b-form-radio-group>

      <small
        v-if="$v.optionRejected.$error"
        class="text-center invalid-feedback"
        >Select an Reason</small
      >
      <base-alert
        type="info text-left"
        class="mb-1 info-min mb-4 p-2"
        v-if="optionRejected === 'Other'"
      >
        <i class="flaticon-circle mr-1"></i>
        Enter the reason for rejecting the reservation
      </base-alert>
      <div
        class="col-12 mt-3"
        :class="{ 'is-invalid': $v.reason.$error }"
        v-if="optionRejected == 'Other'"
      >
        <label class="title-label">Other Reason</label>
        <el-input
          v-model="reason"
          placeholder="Other Reason"
          id="OtherReason"
          name="OtherReason"
          maxlength="200"
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 5 }"
          show-word-limit
        >
        </el-input>
        <small class="invalid-feedback" v-if="$v.reason.$error"
          >Enter a other reason</small
        >
      </div>
      <base-alert
        type="info text-left"
        class="mb-1 info-min mb-4 p-2"
        v-if="optionRejected === 'Wrong Service Rate'"
      >
        <i class="flaticon-circle mr-1"></i>
        Enter updated rate amount
      </base-alert>
      <div
        class="col-xl-12 mt-3"
        v-if="optionRejected === 'Wrong Service Rate'"
        v-bind:class="{ 'is-invalid': $v.updateRate.$error }"
      >
        <label class="title-label">Update Rate</label>
        <BaseNumberInput
          v-model.number="$v.updateRate.$model"
          placeholder="updateRate"
          id="updateRate"
          name="updateRate"
        />

        <small class="invalid-feedback text-left" v-if="$v.updateRate.$error"
          >Enter a update Rate</small
        >
      </div>
      <base-alert
        type="info text-left"
        class="mb-1 info-min mb-4 p-2"
        v-if="optionRejected === 'No Availability'"
      >
        <i class="flaticon-circle mr-1"></i>
        If you have availability on a different date/time please let us know
        below, otherwise leave blank
      </base-alert>
      <div
        class="col-xl-12 mt-3"
        v-if="optionRejected === 'No Availability'"
        v-bind:class="{ 'is-invalid': $v.newAvailability.$error }"
      >
        <label class="title-label">Available Date or Time</label>
        <base-input
          v-model="$v.newAvailability.$model"
          placeholder="newAvailability"
          id="newAvailability"
          name="newAvailability"
          maxlength="45"
        >
        </base-input>

        <small
          class="invalid-feedback text-left"
          v-if="$v.newAvailability.$error"
          >{{
            !$v.newAvailability.minLength || $v.newAvailability.$error
              ? `Minimum ${$v.newAvailability.$params.minLength.min} and Maximun ${$v.newAvailability.$params.maxLength.max} characters.`
              : ""
          }}</small
        >
      </div>
    </div>
    <div
      class="border-top pt-3 text-center col-12 d-flex justify-content-around"
    >
      <base-button
        type="outline-neutral"
        class="min-button "
        @click="closeModalReject()"
        >No</base-button
      >

      <base-button
        type="primary"
        class="min-button ml-auto"
        @click.stop="changeStatusToReject(reservationId)"
        >Yes</base-button
      >
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import endpoint from "../../../Commons/Services/index";
import {
  decimal,
  required,
  requiredIf,
  minLength,
  maxLength,
  minValue
} from "vuelidate/lib/validators";

export default {
  name: "RejectedReservation",
  props: {
    show: {
      type: Boolean,
      default: false,
      description: "(closeable)"
    },
    reservationId: {
      type: String,
      default: () => null,
      description: "(Reservation Id)"
    },
    currency: {
      type: Object,
      default: () => null,
      description: "(currency)"
    }
  },
  data() {
    return {
      optionRejected: "",
      reason: "",
      showRejectModal: true,
      updateRate: "",
      newAvailability: ""
    };
  },
  async created() {
    this.showRejectModal = this.show;
  },
  watch: {
    show: {
      handler: function(current, old) {
        this.showRejectModal = current;
      },
      deep: true
    }
  },
  methods: {
    async changeStatusToReject(reservationId) {
      if (!this.$v.$invalid) {
        let reason = this.getReason(this.optionRejected);
        this.closeModalReject(false);
        await this.changeStatusToRejectByReservationId(
          reservationId,
          "SRB",
          reason
        );
      } else {
        this.$v.$touch();
      }
    },
    async changeStatusToRejectByReservationId(reservationId, status, reason) {
      try {
        this.setLoad(true);
        let {
          data
        } = await endpoint.reservations.services.changeRservationStatus(
          reservationId,
          status,
          reason,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The reservation have been rejected successfully",
            icon: "flaticon-check-3"
          });
          this.onReservationRejected(true);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The reservation could not be rejected",
            icon: "flaticon-remove"
          });
          this.onReservationRejected(false);
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be rejected. Please try again"
        );
        this.onReservationRejected(false);
      }
    },
    closeModalReject(status) {
      this.showRejectModal = status;
      this.resetData();
      this.$emit("close", status);
    },
    resetData() {
      this.optionRejected = "";
      this.reason = "";
      this.$v.$reset();
    },
    getReason(optionRejected) {
      if (optionRejected === "No Availability") {
        return this.newAvailability
          ? `Available on the following date/time: ${this.newAvailability}`
          : "No Availability";
      } else if (optionRejected === "Wrong Service Rate") {
        return `Update Rate: ${this.updateRate} ${this.currency.code}`;
      } else if (optionRejected === "Other") {
        return `${this.reason}`;
      } else {
        return "";
      }
    },
    onReservationRejected(status) {
      this.$emit("onReservationRejected", status);
    },
    ...mapMutations(["setLoad"])
  },
  computed: {
    ...mapGetters(["sesion"])
  },
  validations: {
    optionRejected: {
      required
    },
    reason: {
      minLength: minLength(2),
      maxLength: maxLength(200),
      required: requiredIf(function(value) {
        return this.optionRejected === "Other";
      })
    },
    updateRate: {
      decimal,
      minValue: minValue(0.01),
      required: requiredIf(function(value) {
        return this.$v.optionRejected.$model === "Wrong Service Rate";
      })
    },
    newAvailability: {
      minLength: minLength(2),
      maxLength: maxLength(45)
    }
  }
};
</script>
